/**
 * Shared style tokens for Node UI components.
 * Monotone, shadcn-inspired, consistent with Workflow86 theme.
 */

export const NODE_UI = {
  borderRadius: '6px',
  borderRadiusSm: '4px',
  border: (theme) => `1px solid ${theme.palette.divider}`,
  shadow: '0 1px 2px rgba(0,0,0,0.05)',
  fontSize: {
    label: '12px',
    value: '13px',
    caption: '11px',
  },
  fontWeight: {
    label: 500,
    value: 400,
  },
  spacing: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  input: {
    height: '32px',
    padding: '4px 8px',
  },
};

/**
 * Common sx overrides to make MUI inputs match the shadcn-inspired style.
 */
export const inputSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    fontSize: NODE_UI.fontSize.value,
    borderRadius: NODE_UI.borderRadiusSm,
    backgroundColor: theme.palette.background.default,
    '& fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.text.secondary,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.text.primary,
      borderWidth: '1px',
    },
  },
  '& .MuiInputBase-input': {
    padding: NODE_UI.input.padding,
    fontSize: NODE_UI.fontSize.value,
  },
  '& .MuiInputLabel-root': {
    fontSize: NODE_UI.fontSize.label,
    fontWeight: NODE_UI.fontWeight.label,
    color: theme.palette.text.secondary,
    transform: 'none',
    position: 'relative',
    marginBottom: '4px',
  },
});

export const labelSx = (theme) => ({
  fontSize: NODE_UI.fontSize.label,
  fontWeight: NODE_UI.fontWeight.label,
  color: theme.palette.text.secondary,
  lineHeight: 1.4,
  marginBottom: '4px',
  userSelect: 'none',
});

export const stopPropagation = (e) => {
  e.stopPropagation();
};

export const getCanvasSurfaceProps = (canvas) =>
  canvas
    ? {
        className: "nodrag nopan nowheel",
        onMouseDown: stopPropagation,
        onClick: stopPropagation,
        onPointerDown: stopPropagation,
      }
    : {};
